import { Col, Form, Row } from 'antd';

import { MilesForm } from 'components';

import { fields } from './overviewHelpers';

import { snapStore } from '../../store';

const { useForm } = Form;

export const Overview = () => {
  const overviewFormValues = snapStore((state) => state.overviewFormValues);

  const [form] = useForm();

  const { duplicateOf, duplicates, externalId, collectorId } = overviewFormValues;

  return (
    <Row className='mb-7'>
      <Col xs={18} xl={14} xxl={10}>
        <MilesForm
          disabled
          form={form}
          title='Overview'
          labelCol={{ span: 7 }}
          wrapperCol={{ span: 17 }}
          fields={fields(collectorId, duplicateOf, duplicates, externalId)}
          initialValues={overviewFormValues}
        />
      </Col>
    </Row>
  );
};
